module.exports = __webpack_public_path__ + "static/media/joinfree-en.29350751.jpg";